import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import FromFieldText from '../../../atoms/FromFieldText';
import FromFieldDate from '../../../atoms/FromFieldDate';
import FromSpFieldText from '../../../atoms/FromSpFieldText';
import { getAllocation, saveAllocation, getCountAinNo, getTagChildCount } from '../../../services/asset.service';
import { getDivisionList } from '../../../services/user.service';
import * as CryptoJS from "crypto-js";

Date.prototype.dbFormatedDate = function () {

    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }
    return year + '-' + month + '-' + day;
    //return `${this.getFullYear()}-${this.getMonth()+1}-${this.getDate()-1}`
}

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
        //return `${dte.getFullYear()}-${dte.getMonth()+1}-${dte.getDate()}`;
    } else {
        return null;
    }
}

const TEXT_REGEX = /^[A-Za-z0-9-_/.@= ]{1,155}$/;

const Email_REGX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//const NUMBER_REGEX = /^[0-9]{1,15}$/;

function SingleAllocation() {

    const [assetInfo, setAssetInfo] = useState({});
    const [validName, setValidName] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);
    //const [allocate, setAllocate] = useState('');
    const [tag, setTag] = useState('');
    const [ErrTag, setErrTag] = useState(false);

    const [division, setDivision] = useState('');
    const [divisions, setDivisions] = useState([]);
    const [ErrDivision, setErrDivision] = useState(false);
    const [allocation_status, setAllocationStatus] = useState();
    const [premises, setPremises] = useState('');
    const [ErrPremises, setErrPremises] = useState(false);

    const [floor, setFloor] = useState('');
    const [ErrFloor, setErrFloor] = useState(false);

    const [siteId, setSiteId] = useState('');
    const [ErrSiteId, setErrSiteId] = useState(false);

    const [userType, setUserType] = useState('');
    const [ErrUserType, setErrUserType] = useState(false);

    const [userDepartment, setUserDepartment] = useState('');
    const [ErrUserDepartment, setErrUserDepartment] = useState(false);

    const [employeeId, setEmployeeId] = useState('');
    const [ErrEmployeeId, setErrEmployeeId] = useState(false);

    const [employeeName, setemployeeName] = useState('');
    const [ErrEmployeeName, setErrEmployeeName] = useState(false);
    const [effectivedate, setEffectiveDate] = useState('');
    const [ErrEffectiveDate, setErrEffectiveDate] = useState(false);
    const [assetinusedate, setAssetInuseDate] = useState('');

    //const [invoiceDate,setInvoiceDate] = useState('');
    //const [initiationDate,setInitiationDate] = useState('');
    //const [financialsClassification,setFinancialsClassification] = useState('');
    //const [approvalDate,setApprovalDate] = useState('');
    //const [movementReason,setMovementReason] = useState('');

    const [tagCount, setTagCount] = useState('');

    const [userMailId, setUserMailId] = useState('');
    const [ErrUserMailId, setErrUserMailId] = useState(false);

    const [alternativeVerification, setAlternativeVerification] = useState('');
    const [ErrAlternativeVerification, setErrAlternativeVerification] = useState(false);

    const [rackId, setRackId] = useState('');
    const [ErrRackId, setErrRackId] = useState(false);

    const [childAllocation, setChildAllocation] = useState('');
    const [ErrChildAllocation, setErrChildAllocation] = useState(false);
    const [auditInfo, setAuditInfo] = useState([]);

    const [AINAndRef, setAINAndRef] = useState('');
    const [PrefixAINAndRef, setPrefixAINAndRef] = useState('');

    const resetAssetInfo = function () {
        setTag('');
        setDivision('');
        setPremises('');
        setFloor('');
        setSiteId('');
        setUserType('');
        setUserDepartment('');
        setEmployeeId('');
        setemployeeName('');
        setEffectiveDate('');
        setChildAllocation('');
    }

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Tag = query.get('tag');
    const allocate = query.get('allocate');
    const elementRef = useRef();
    useEffect(() => {
        if (Tag !== '' && Tag !== null) {
            const decryptedBytes = CryptoJS.AES.decrypt(Tag.replace(/ /g, '+'), process.env.REACT_APP_ENCRYPT_SECRET_KEY);
            // Convert the decrypted bytes to a string
            const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
            const decryptedTag = decrypt_data.tag;
            getTagAssetInfo(decryptedTag);
            //alert(decryptedTag);
        } else {
            resetAssetInfo();
            generateAINAndRef(-1); // means insert new allocation
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
        getDivisionList(oData).then(res => {
            if (res?.data?.data?.length) setDivisions(res.data.data);
        });

        getTagChildCount(oData).then(function (res) {
            const tagCount = res.data.data.childTagCount.tag_count;
            setTagCount(tagCount);
            setChildAllocation(tagCount > 0 ? "Yes" : "No");
        })
        if (PrefixAINAndRef) {
            let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'ain_no': PrefixAINAndRef },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData1 = { 'token': EncryptData1 };
            getCountAinNo(oData1).then(res => {
                //setClasifications(res.data.data);
                generateAINAndRef(res?.data?.total);
            });
        }
    }, [PrefixAINAndRef]);
    const generateAINAndRef = function (lastNumber = '') {
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // zero-padded month
        const year = String(date.getFullYear()).slice(-2);          // last 2 digits of year
        const divisionCode = sessionStorage.getItem('LoggedInDivisionCode') || '0000';
        const nextSerial = String(lastNumber + 1).padStart(5, '0'); // e.g., 00001
        if (lastNumber < 0) {
            let preainCode = `AIN${divisionCode}${month}${year}`;
            //alert(preainCode);
            setPrefixAINAndRef(preainCode);
        } else {
            let ainCode = `AIN${divisionCode}${month}${year}${nextSerial}`;
            setAINAndRef(ainCode);
        }
        //const refTag = `${nextSerial}-1`;
    };
    const generateSubAINAndRef = function (ainCode) {
        if (typeof ainCode === 'string' && ainCode.trim() !== '') {
            // Extract base AIN (before any dash)
            const baseAIN = ainCode.split('-')[0];
            let EncryptData2 = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': {
                    'ain_no': baseAIN,
                    'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                    'division_id': sessionStorage.getItem('LoggedInDivisionId')
                },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData2 = { 'token': EncryptData2 };
            getCountAinNo(oData2).then(res => { //console.log(res?.data?.total);
                const count = res?.data?.total || 0;
                let sub_ainCode = `${baseAIN}-${count}`;
                //alert(ainCode);
                setAINAndRef(sub_ainCode);
            });
        }
        //const refTag = `${nextSerial}-1`;
    };

    const getTagAssetInfo = function (decryptedTag) {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': decryptedTag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData1 = { 'token': EncryptData }
        getAllocation(oData1).then(function (res) {
            //getTransferData(Tag).then(function(res){
            if (res?.data?.data?.assetInfo) {
                var aInfo = res.data.data.assetInfo;
                var aLogInfo = res.data.data.logInfo;
                var aTranInfo = res.data.data.transferInfo;
                //console.log(Info);
                setAssetInfo(aInfo);
                setTag(aInfo.tag);
                setDivision(aInfo.division_id ? aInfo.division_id : '');
                setAllocationStatus(aInfo.allocation_status);

                setAssetInuseDate(aInfo.asset_in_use_date ? (new Date(aInfo.asset_in_use_date)) : '');

                const existingAin = (aInfo.ain_no && String(aInfo.ain_no).trim() !== '' && String(aInfo.ain_no).trim() !== '0')
                    ? aInfo.ain_no
                    : (aTranInfo?.ain_no && String(aTranInfo.ain_no).trim() !== '' && String(aTranInfo.ain_no).trim() !== '0')
                        ? aTranInfo.ain_no
                        : '';

                if (existingAin) {
                    if (allocate || aInfo.allocation_status === 'Y') {
                        generateSubAINAndRef(existingAin);
                    } else {
                        setAINAndRef(existingAin);
                    }
                } else {
                    const date = new Date();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = String(date.getFullYear()).slice(-2);
                    const divisionCode = sessionStorage.getItem('LoggedInDivisionCode') || '0000';
                    let preainCode = `AIN${divisionCode}${month}${year}`;

                    let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
                        'param_data': {
                            'ain_no': preainCode,
                            'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                            'division_id': sessionStorage.getItem('LoggedInDivisionId')
                        },
                        'authToken': sessionStorage.getItem('LoggedInToken'),
                    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                    let oData1 = { 'token': EncryptData1 };
                    getCountAinNo(oData1).then(res => {
                        const totalCount = res?.data?.total || 0;
                        generateAINAndRef(totalCount);
                    });
                }
            } else {
                setErrMsg('Assets Not Found');
            }
            if (res?.data?.data?.transferInfo) {
                var aInfo = res.data.data.assetInfo;
                var aLogInfo = res.data.data.logInfo;
                var Info = res.data.data.transferInfo;
                setAuditInfo(Info);
                //setInvoiceDate((new Date(aInfo.invoice_date)));
                //alert(Info.effective_date);
                setDivision(Info.division ? Info.division : '');
                setPremises(Info.premises);
                setFloor(Info.floor);
                setSiteId(Info.site_id);
                setUserType(Info.user_type);
                setUserDepartment(Info.user_department);
                setEmployeeId(Info.employee_id);
                setemployeeName(Info.employee_name);
                setUserMailId(Info.user_mail_id);
                setRackId(Info.rack_id);
                setAlternativeVerification(Info.alternative_verification);

                setEffectiveDate(Info.effective_date ? (new Date(Info.effective_date)) : '');
                if (res.data.data?.logInfo && (aLogInfo.unallocate_date !== null) && (aLogInfo.unallocate_date > Info.effective_date)) {
                    //console.log('aLogInfo.unallocate_date');
                    //console.log(aLogInfo.unallocate_date);
                    setAssetInuseDate(aLogInfo.unallocate_date ? (new Date(aLogInfo.unallocate_date)) : '');
                } else if (Info.effective_date && (Info.effective_date !== null)) {
                    setAssetInuseDate(Info.effective_date ? (new Date(Info.effective_date)) : '');
                    //console.log('Info.effective_date');
                    //console.log(Info.effective_date);
                } else {
                    setAssetInuseDate(aInfo.invoice_date ? (new Date(aInfo.invoice_date)) : '');
                    //console.log('aInfo.invoice_date');
                    //console.log(aInfo.invoice_date);
                }
                //setFinancialsClassification(Info.financials_classification);
            }
        })
    }
    const getTagInfo = function () {
        resetAssetInfo();
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': { 'tag': tag },
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
        getTagChildCount(oData).then(function (res) {
            const tagCount = res.data.data.childTagCount.tag_count;
            setTagCount(tagCount);
            setChildAllocation(tagCount > 0 ? "Yes" : "No");
        })
        getAllocation(oData).then(function (res) {
            //console.log(res.data.data);
            var aInfo = {};
            //getTransferData(tag).then(function(res){
            if (res?.data?.data?.assetInfo) {
                setErrMsg('');
                aInfo = res.data.data.assetInfo;
                var aLogInfo = res.data.data.logInfo;
                var aTranInfo = res.data.data.transferInfo;
                setAssetInfo(aInfo);
                setDivision(aInfo.division_id ? aInfo.division_id : '');
                setAllocationStatus(aInfo.allocation_status);
                //console.log(aLogInfo);
                //setInvoiceDate((new Date(aInfo.invoice_date)));

                const existingAin = (aInfo.ain_no && String(aInfo.ain_no).trim() !== '' && String(aInfo.ain_no).trim() !== '0')
                    ? aInfo.ain_no
                    : (aTranInfo?.ain_no && String(aTranInfo.ain_no).trim() !== '' && String(aTranInfo.ain_no).trim() !== '0')
                        ? aTranInfo.ain_no
                        : '';

                if (existingAin) {
                    if (allocate || aInfo.allocation_status === 'Y') {
                        generateSubAINAndRef(existingAin);
                    } else {
                        setAINAndRef(existingAin);
                    }
                } else {
                    const date = new Date();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = String(date.getFullYear()).slice(-2);
                    const divisionCode = sessionStorage.getItem('LoggedInDivisionCode') || '0000';
                    let preainCode = `AIN${divisionCode}${month}${year}`;

                    let EncryptData1 = CryptoJS.AES.encrypt(JSON.stringify({
                        'param_data': {
                            'ain_no': preainCode,
                            'company_id': sessionStorage.getItem('LoggedInCompanyId'),
                            'division_id': sessionStorage.getItem('LoggedInDivisionId')
                        },
                        'authToken': sessionStorage.getItem('LoggedInToken'),
                    }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
                    let oData1 = { 'token': EncryptData1 };
                    getCountAinNo(oData1).then(res => {
                        const totalCount = res?.data?.total || 0;
                        generateAINAndRef(totalCount);
                    });
                }
                setTag(aInfo.tag);
                ////console.log(aLogInfo.length);
                if (res.data.data?.logInfo && (aLogInfo.unallocate_date !== null) && (aLogInfo.unallocate_date > aTranInfo?.effective_date)) {
                    //console.log('aLogInfo.unallocate_date');
                    //console.log(aLogInfo.unallocate_date);
                    setAssetInuseDate(aLogInfo.unallocate_date ? (new Date(aLogInfo.unallocate_date)) : '');
                } else if (aTranInfo?.effective_date && (aTranInfo.effective_date !== null)) {
                    setAssetInuseDate(aTranInfo.effective_date ? (new Date(aTranInfo.effective_date)) : '');
                    //console.log('aTranInfo.effective_date');
                    //console.log(aTranInfo.effective_date);
                } else {
                    setAssetInuseDate(aInfo?.invoice_date ? (new Date(aInfo.invoice_date)) : '');
                    //console.log('aInfo.invoice_date');
                    //console.log(aInfo.invoice_date);
                }


            } else {
                setAssetInfo({});
                setErrMsg('Assets Not Found');
            }
            if (res?.data?.data?.transferInfo) {
                var Info = res.data.data.transferInfo;
                //alert(Info.division);
                setAuditInfo(Info);
                //setDivision(Info.division ? Info.division : '');
                setPremises(Info.premises);
                setFloor(Info.floor);
                setSiteId(Info.site_id);
                setRackId(Info.rack_id);
                setUserType(Info.user_type);
                setUserDepartment(Info.user_department);
                setEmployeeId(Info.employee_id);
                setemployeeName(Info.employee_name);
                setUserMailId(Info.user_mail_id);
                setAlternativeVerification(Info.alternative_verification);
                setChildAllocation(Info.child_allocation);
                setEffectiveDate(Info.effective_date ? (new Date(Info.effective_date)) : '');

                //setFinancialsClassification(Info.financials_classification);
            }
        })
    }

    const handleUsetType = (e) => {
        setUserType(e.target.value);

        if (e.target.value !== "Individual") {

            setEmployeeId('');
            setUserMailId('');
            setemployeeName('');
        }
    };


    const handleVerification = (e) => {
        setAlternativeVerification(e.target.value);
    }
    const handleChildAllocation = (e) => {
        if (tagCount > 0 || tagCount === 0) {
            return;
        }
        setChildAllocation(e.target.value);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        var valid_Name = true;
        // if button enabled with JS hack
        //const v1 = TEXT_REGEX.test(division);
        //alert(tag);
        if (!TEXT_REGEX.test(tag) && tag !== 0) {
            setErrTag('TAG is required');
            valid_Name = false;
            //return;
        } else {
            setErrTag('');
        }
        if (!TEXT_REGEX.test(division)) {
            setErrDivision('Division is required');
            valid_Name = false; //alert(valid_Name);
            //return;
        } else {
            setErrDivision('');
        }
        if (!TEXT_REGEX.test(premises)) {
            setErrPremises('Premises is required');
            valid_Name = false;
            //return;
        } else {
            setErrPremises('');
        }
        if (!TEXT_REGEX.test(floor)) {
            setErrFloor('Floor is required');
            valid_Name = false;
            //return;
        } else {
            setErrFloor('');
        }
        if (!TEXT_REGEX.test(siteId)) {
            setErrSiteId('Site Id is required');
            valid_Name = false;
            //return;
        } else {
            setErrSiteId('');
        }
        if (!TEXT_REGEX.test(userType)) {
            setErrUserType('User Type is required');
            valid_Name = false;
            //return;
        } else {
            setErrUserType('');
        }
        if (!['Individual', 'Team', 'General'].includes(userType)) {
            setErrUserType(' User Type should be one of the allowed values (Individual, Team, General).');
        } else {
            setErrUserType('');
        }
        if (!TEXT_REGEX.test(userDepartment)) {
            setErrUserDepartment('User Department is required');
            valid_Name = false;
            //return;
        } else {
            setErrUserDepartment('');
        }
        if (!TEXT_REGEX.test(employeeId) && (userType === "Individual")) {
            setErrEmployeeId('Employee Id is required');
            valid_Name = false;
            //return;
        } else {
            setErrEmployeeId('');
        }
        if (!TEXT_REGEX.test(employeeName) && (userType === "Individual")) {
            setErrEmployeeName('Employee Name is required');
            valid_Name = false;
            //return;
        } else {
            setErrEmployeeName('');
        }
        if (effectivedate == '') {
            setErrEffectiveDate('Effective Date is required');
            valid_Name = false;
            //return;
        } else {
            setErrEffectiveDate('');
        }
        if (userMailId == '' && (userType === "Individual")) {
            setErrUserMailId('User Mail id is required');
            valid_Name = false;

            //return;
        } else if (!Email_REGX.test(userMailId) && (userType === "Individual")) {
            setErrUserMailId('Enter user mail id is not in correct format');
            valid_Name = false;

        } else {
            setErrUserMailId('');
        }
        if (alternativeVerification == '') {
            setErrAlternativeVerification('Alternative verification is required');
            valid_Name = false;
            //return;
        } else {
            setErrAlternativeVerification('');
        }
        if (childAllocation == '') {
            setErrChildAllocation('Alternative verification is required');
            valid_Name = false;
            //return;
        } else {
            setErrChildAllocation('');
        }
        //alert(valid_Name);
        if (valid_Name) { //alert('test1');
            saveData(); //submit form
        } else {
            return false;
        }
    }

    const saveData = function () {
        var obj = {
            'rack_id': rackId,
            'user_mail_id': userMailId,
            'alternative_verification': alternativeVerification,
            'division': division,
            'premises': premises,
            'floor': floor,
            'site_id': siteId,
            'user_type': userType,
            'user_department': userDepartment,
            'employee_id': employeeId,
            'employee_name': employeeName,
            'effective_date': getFormatedDate(effectivedate),
            'tag': tag,
            'child_allocation': childAllocation,
            'ain_no': AINAndRef,
            'company_id': sessionStorage.getItem('LoggedInCompanyId'),
            'division_id': sessionStorage.getItem('LoggedInDivisionId'),
            'created_by': sessionStorage.getItem('LoggedInUserId'),
        }
        var objAudit = {
            'audit_module': 'Alloction', 'audit_method': 'Allocated',
            'audit_tag': tag, 'old_values': auditInfo, 'new_values': obj
        }
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'param_data': obj, 'audit_params': objAudit,
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData }
        try {
            saveAllocation(oData).then(function (res) {
                ////console.log(res);
                if ((typeof (res.data.errors) != "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    resetAssetInfo();
                }
            });

            //setValidName(false);
        } catch (err) {
            setSuccess(false);
            if (!err?.data) {
                //console.log(err);
                setErrMsg('No Server Response');
            } else if (err.data?.status === 409) {
                setErrMsg('data already exist');
            } else {
                setErrMsg('Insert/Update Failed');
            }
            //elementRef.current.focus();
        }
    }

    return (
        <div className="al-page" id="single-allocation-page">
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-person-plus-fill" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">Single Allocation</h5>
                        <p className="al-page-subtitle">Allocate or update an asset for a specific user or location</p>
                    </div>
                </div>
                <div className="al-record-badge">
                    <a href={'/view-allocation'} style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <i className='bi bi-list-ul'></i> Allocation List
                    </a>
                </div>
            </div>

            {/* Error / Success Messages */}
            {(errMsg || success) && (
                <div className="al-grid-card mb-3" style={{ padding: '12px 20px', backgroundColor: success ? '#eef7fd' : '#fef2f2', borderColor: success ? '#b6d9f0' : '#fecaca' }}>
                    {errMsg && <span style={{ color: '#dc2626', fontWeight: 600, fontSize: '0.86rem' }}><i className="bi bi-exclamation-triangle-fill" /> {errMsg}</span>}
                    {success && <span style={{ color: '#0e8aca', fontWeight: 600, fontSize: '0.86rem' }}><i className="bi bi-check-circle-fill" /> {success}</span>}
                </div>
            )}
            {!success && !errMsg && (
                <div className="al-grid-card mb-3" style={{ padding: '12px 20px', backgroundColor: '#f8f9fc', borderColor: '#e2e6ef' }}>
                    <span style={{ color: '#1a3a5c', fontSize: '0.86rem' }}><i className="bi bi-info-circle-fill" /> Please fill all mandatory fields.</span>
                </div>
            )}

            {/* Top TAG Card */}
            <div className="al-filter-card">
                <div className="al-filter-card-header">
                    <span className="al-filter-card-title">
                        <i className="bi bi-tag-fill" /> Asset Search
                    </span>
                </div>
                <div className="al-filter-card-body">
                    {!(Tag !== '' && Tag !== null) ? (
                        <div className="al-filter-grid">
                            <div className="al-filter-group al-filter-group-wide">
                                <label className="al-filter-label">TAG</label>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <input
                                        type="text"
                                        className="al-form-input"
                                        placeholder="Enter the asset TAG"
                                        value={assetInfo.tag || tag}
                                        onChange={(event) => setTag(event.target.value)}
                                        style={{ maxWidth: '300px' }}
                                    />
                                    <button onClick={getTagInfo} type="button" className="al-btn al-btn-primary">
                                        <i className="bi bi-search"></i> Search
                                    </button>
                                    <a href="/single-allocation" style={{ textDecoration: 'none' }}>
                                        <button type="button" className="al-btn al-btn-outline">
                                            <i className="bi bi-arrow-clockwise"></i> Reset
                                        </button>
                                    </a>
                                </div>
                                {ErrTag && <span className="al-field-error"><i className="bi bi-exclamation-circle" /> {ErrTag}</span>}
                            </div>
                        </div>
                    ) : (
                        <div className="al-filter-grid">
                            <div className="al-filter-group al-filter-group-wide" style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1a3a5c' }}>Editing TAG: {assetInfo.tag}</span>
                                <a href="/single-allocation" className="al-btn al-btn-outline al-btn-sm" style={{ marginLeft: '15px' }}>
                                    <i className="bi bi-arrow-left"></i> Back to Search
                                </a>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Form Content */}
            <div className="al-grid-card">
                <form onSubmit={handleSubmit}>
                    <div className="al-grid-card-header">
                        <span className="al-grid-card-title">
                            <i className="bi bi-card-checklist" /> Allocation Details
                        </span>
                    </div>

                    <div style={{ padding: '24px' }}>
                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromFieldText label="Allocation No." inputValue={AINAndRef} readOnly="readonly" />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <FromFieldText label="TAG" inputValue={assetInfo.tag ? assetInfo.tag : ''} readOnly="readonly" />
                            </div>
                        </div>

                        <div className="row mt-2">
                            <div className="col-12 col-md-6 mb-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1a3a5c' }}>Division <span className="star error text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-6">
                                        <input className='al-form-input' type='text' readOnly value={
                                            divisions && divisions.length > 0 ? divisions.filter((option) => division === option.id)
                                                .map((selectedOption) => selectedOption.division_name).join(', ') : ''} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText star="*" label="Premises" inputValue={premises} setInputValue={setPremises} setErrorMsg={ErrPremises} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText star="*" label="Floor" inputValue={floor} setInputValue={setFloor} setErrorMsg={ErrFloor} />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText star="*" label="Site ID" inputValue={siteId} setInputValue={setSiteId} setErrorMsg={ErrSiteId} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText star="*" label="Rack Id" inputValue={rackId} setInputValue={setRackId} setErrorMsg={ErrRackId} />
                            </div>
                            <div className="col-12 col-md-6 mb-3">

                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1a3a5c' }}>User Type <span className="star error text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-6">
                                        <select onChange={handleUsetType} name="user_type" className="al-form-select">
                                            <option value="">Select user type</option>
                                            <option value="Individual" selected={userType === "Individual" ? "selected" : ""}>Individual</option>
                                            <option value="Team" selected={userType === "Team" ? "selected" : ""}>Team</option>
                                            <option value="General" selected={userType === "General" ? "selected" : ""}>General</option>
                                        </select>
                                        {ErrUserType && <span className="al-field-error mt-1"><i className="bi bi-exclamation-circle" /> {ErrUserType}</span>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText star="*" label="User Department" inputValue={userDepartment} setInputValue={setUserDepartment} setErrorMsg={ErrUserDepartment} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText label="Employee ID" star="*" inputValue={employeeId} setInputValue={setEmployeeId} setErrorMsg={ErrEmployeeId} readOnly={(userType !== "Individual") ? "readOnly" : ""} />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText label="Employee Name" star="*" inputValue={employeeName} setInputValue={setemployeeName} setErrorMsg={ErrEmployeeName} readOnly={(userType !== "Individual") ? "readOnly" : ""} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromSpFieldText label="User Mail ID" star="*" inputValue={userMailId} setInputValue={setUserMailId} setErrorMsg={ErrUserMailId} readOnly={(userType !== "Individual") ? "readOnly" : ""} />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1a3a5c' }}>Eligible for Alt Verification</label>
                                    </div>
                                    <div className="col-md-6">
                                        <select onChange={handleVerification} name="alternative_verification" className="al-form-select">
                                            <option value="">Select Eligible...</option>
                                            <option value="Yes" selected={alternativeVerification === "Yes" ? "selected" : ''}>Yes</option>
                                            <option value="No" selected={alternativeVerification === "No" ? "selected" : ''}>No</option>
                                        </select>
                                        {ErrAlternativeVerification && <span className="al-field-error mt-1"><i className="bi bi-exclamation-circle" /> {ErrAlternativeVerification}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md-6 mb-3">
                                <FromFieldDate minDate={assetinusedate ? assetinusedate : effectivedate} label="Start Date of Alloc." star="*" inputValue={effectivedate} setInputValue={setEffectiveDate} setErrorMsg={ErrEffectiveDate} />
                            </div>
                            <div className="col-12 col-md-6 mb-3">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label style={{ fontSize: '0.82rem', fontWeight: 600, color: '#1a3a5c' }}>Select for child alloc. <span className="star error text-danger">*</span></label>
                                    </div>
                                    <div className="col-md-6">
                                        <select onChange={handleChildAllocation} disabled={childAllocation !== "Yes"} name="childAllocation" className="al-form-select">
                                            <option value="">Select for child allocation</option>
                                            <option value="Yes" selected={childAllocation === "Yes" ? "selected" : ''}>Yes</option>
                                            <option value="No" selected={childAllocation === "No" ? "selected" : ''}>No</option>
                                        </select>
                                        {ErrChildAllocation && <span className="al-field-error mt-1"><i className="bi bi-exclamation-circle" /> {ErrChildAllocation}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="al-filter-actions" style={{ padding: '16px 24px', backgroundColor: '#f8f9fc', borderTop: '1px solid #e2e6ef', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                        {(Tag !== '' && Tag !== null) ? (
                            <>
                                {(allocate) ? (
                                    <button type="submit" className="al-btn al-btn-primary"><i className="bi bi-check2-circle" /> Reallocate</button>
                                ) : (
                                    <button type="submit" className="al-btn al-btn-primary"><i className="bi bi-arrow-repeat" /> Update</button>
                                )}
                                <a href={'/single-view-allocation?tag=' + Tag} className="al-btn al-btn-outline"><i className="bi bi-x-circle" /> Cancel</a>
                            </>
                        ) : (allocation_status === 'N') ? (
                            <button type="submit" className="al-btn al-btn-primary"><i className="bi bi-check2-circle" /> Allocate</button>
                        ) : null}
                    </div>
                </form>
            </div>
            {/* Added spacing at bottom */}
            <div style={{ paddingBottom: '30px' }}></div>
        </div>
    );
}

export default SingleAllocation;
